import { useMutation } from "@tanstack/react-query";
import {
  PositionAddParams,
  positionAdd,
} from "common/api/unos_rad/unos_position";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseUnosPositionAddParams = {
  invalidateKeys?: string[];
  successHandle?: Function;
};

export const useUnosPositionAdd = (hookParams?: UseUnosPositionAddParams) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: positionAddMutate } = useMutation({
    mutationFn: async (positionAddParams: PositionAddParams) =>
      await positionAdd(positionAddParams),
    onSuccess: (response) => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }
      if (hookParams?.successHandle) {
        hookParams.successHandle(response);
      }
    },
  });

  return { positionAddMutate };
};
